import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Timeline.css';

const items = [
  {
    index: '01',
    year: '~5 лет назад',
    title: 'HTML & CSS',
    description: 'Основы верстки, адаптивный дизайн, первые шаги в веб-разработке. Понял как работает браузер изнутри.',
    accent: '#5227ff',
  },
  {
    index: '02',
    year: '~4.5 года назад',
    title: 'JavaScript',
    description: 'Первый интерактивный сайт. DOM, события, асинхронность — погружение в мир программирования.',
    accent: '#5227ff',
  },
  {
    index: '03',
    year: '~4 года назад',
    title: 'Django & PostgreSQL',
    description: 'Серверная разработка, ORM, миграции, REST API. Первая база данных, первый бэкенд в продакшн.',
    accent: '#5227ff',
  },
  {
    index: '04',
    year: '~3 года назад',
    title: 'Первый масштабный проект',
    description: 'Сложный функционал, интеграция внешних API, работа с реальными данными и нагрузкой.',
    accent: '#5227ff',
  },
  {
    index: '05',
    year: '~2.5 года назад',
    title: 'FastAPI & React',
    description: 'Современный fullstack-стек. Async Python, Pydantic, WebSocket. На фронте — React и состояние.',
    accent: '#5227ff',
  },
  {
    index: '06',
    year: '~1 год назад',
    title: 'Фриланс',
    description: 'Первые коммерческие заказы, реальные клиенты, жёсткие дедлайны.',
    accent: '#CCFF00',
  },
];

function TimelineCard({ item, side }) {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.3, once: false });

  return (
    <motion.div
      ref={ref}
      initial={{ scale: 0.75, opacity: 0 }}
      animate={inView ? { scale: 1, opacity: 1 } : { scale: 0.75, opacity: 0 }}
      transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`tl-card ${side === 'right' ? 'tl-card--right' : 'tl-card--left'}`}
    >
      <div className="tl-card-inner" style={{ '--accent': item.accent }}>
        <div className="tl-card-top">
          <span className="tl-index">{item.index}</span>
          <span className="tl-year">{item.year}</span>
        </div>
        <h3 className="tl-title">{item.title}</h3>
        <p className="tl-desc">{item.description}</p>
        <div className="tl-line" />
      </div>
    </motion.div>
  );
}

export default function Timeline() {
  return (
    <section className="tl-section">
      <div className="tl-header">
        <span className="tl-eyebrow">История</span>
        <h2 className="tl-heading">Мой путь</h2>
      </div>

      <div className="tl-track">
        {/* center line */}
        <div className="tl-line-center" />

        {items.map((item, i) => {
          const side = i % 2 === 0 ? 'left' : 'right';
          return (
            <div key={i} className="tl-row">
              {/* left slot */}
              <div className="tl-slot tl-slot--left">
                {side === 'left' && <TimelineCard item={item} side="left" />}
              </div>

              {/* dot */}
              <motion.div
                className="tl-dot"
                style={{ '--accent': item.accent }}
                initial={{ scale: 0, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: 0.1 }}
              />

              {/* right slot */}
              <div className="tl-slot tl-slot--right">
                {side === 'right' && <TimelineCard item={item} side="right" />}
              </div>
            </div>
          );
        })}

        {/* Future row */}
        <div className="tl-row">
          <div className="tl-slot tl-slot--left" />
          <motion.div
            className="tl-dot tl-dot--future"
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3 }}
          />
          <div className="tl-slot tl-slot--right">
            <motion.div
              initial={{ scale: 0.75, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
              className="tl-card tl-card--right"
            >
              <div className="tl-card-inner tl-card-inner--future" style={{ '--accent': '#CCFF00' }}>
                <div className="tl-card-top">
                  <span className="tl-index">∞</span>
                  <motion.span
                    animate={{ opacity: [1, 0.3, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="tl-year"
                  >
                    Сейчас и дальше
                  </motion.span>
                </div>
                <h3 className="tl-title">И это только начало...</h3>
                <p className="tl-desc">
                  Новые технологии, масштабные проекты, бесконечный рост.
                </p>
                <div className="tl-line" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
